import React, { useEffect, useMemo, useState } from 'react';
import {
  Col,
  InputNumber,
  Modal,
  Row,
  Button,
  Tabs,
  Select,
  Divider,
  notification,
  Card,
  message,
  Spin,
  Form,
} from 'antd';
import DataGrid from 'components/DataGrid';
import ParListSelect from 'components/ParListSelect';
import InputRate from 'components/InputRate';
import PricingListSelect from 'components/PricingListSelect';
import ServiceScheduleModal from 'components/ServiceScheduleModal';
import ScheduleButton from 'components/ScheduleButton';
import IUpdate from 'icons/IUpdate';
import IAdd from 'icons/IAdd';
import * as finEngine from 'services/finEngine';
import { ParServiceStep } from 'services/pricing';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { toCurrency, toRate } from 'utils/utils';
import GetLabel from 'DisplayFramework/components/GetLabel';
import moment from 'moment';
import Value from 'components/Value';
import { shouldUpdateCompare } from 'utils/utils2';
import InputCurrency from 'components/InputCurrency';
import { debounce, isEmpty } from 'lodash';
import FormInput from 'components/FormInput';
import { Pricing } from 'services/proposal';
import { useForm } from 'antd/lib/form/Form';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { ServiceToElement } from 'pages/ProposalV3/PropDetail/ServiceToElement';
import { pricingToElement } from 'pages/ProposalV3/PropDetail/pricingToElement';

const { TabPane } = Tabs;

export type SimpleServElementModalProps = {
  updateService?: boolean;
  visible?: boolean;
  assetid?: number;
  onSave: (serv: any, action: string) => void;
  onClose?: any;
  record?: any;
  offerid?: any;
  finschedule?: any;
  ctegraceperiodduration: number;
  ctefinancedamount: number;
  cteinvestamount: number;
  assetamount: number;
  ctestartdate: string;
  cteduration: number;
  index?: number;
  assets?: any;
  cteidparent: number;
  zindex?: number;
};

const SimpleServElementModal = (props: SimpleServElementModalProps) => {
  const {
    onSave,
    visible = false,
    onClose,
    record,
    updateService = false,
    offerid,
    finschedule,
    ctegraceperiodduration,
    ctefinancedamount,
    cteinvestamount,
    assetamount,
    ctestartdate,
    cteduration,
    index,
    assets,
    cteidparent,
  } = props;
  const { getComponentLabel } = useDisplayFrameworkContext();

  const initobj: any = {
    servtype: '',
    servbasis: '',
    calculatedamountbasis: '',
    servduration: '',
    servperiodicity: '',
    servdurationdefault: 0,
    servcalculationmethod: '',
    servfixedamount: 0,
    servbasisamount: 0,
    servpercentage: 0,
    marginoncalulatedcamount: 0,
    additionalcostaftermargin: 0,
  };

  const initialValues: any = {
    offer: {
      ofrid: 0,
      ofrtype: '',
      ofrlabel: '',
      ofrdescription: '',
    },
    ofrid: 0,
    ofrlabel: '',
    ofrtype: '',
    assetid: 0,
    conElemAssets: [],
    conElemSchedules: [],
    conElemSteps: [],
    conElemAttributes: [],
    conElemServiceSteps: [],
    ctebilligdate: '',
    cteactuarialrate: 0,
    ctecalculationbasis: '',
    ctecalculationtype: '',
    ctecategory: '',
    ctecategorylabel: '',
    ctedeferredinterest: 0,
    ctedeferredinterestmethod: '',
    ctedeferredinterestnominalrate: null,
    ctedepositamount: null,
    ctedepositcoef: null,
    ctedepositinterest: 0,
    ctedepositinterestmethod: '',
    ctedepositnominalrate: null,
    ctedescription: '',
    ctedirection: '',
    cteduration: 0,
    cteendamount: 0,
    cteenddate: '',
    ctefinancedamount: 0,
    ctefirstpayment: 0,
    ctefirstpaymentcoef: 0,
    ctefirstpaymentdate: null,
    ctefree1: '',
    ctegraceperiodduration: 0,
    ctegraceperiodmethod: '',
    cteid: 0,
    cteidparent: 0,
    cteinitialamount: 0,
    cteinstallmentamount: 0,
    cteinterestmethod: '',
    cteinvestamount: 0,
    ctenominalrate: 0,
    cteorder: 0,
    ctepartamount: 0,
    ctepartdays: 0,
    ctepartmethod: '',
    ctepartrate: 0,
    servbasis: 0,
    ctepaymentterm: '',
    cteperiodicity: '',
    cteratebasis: '',
    cterateformula: '',
    cterateperiodicity: '',
    cteratespread: 0,
    cterateterm: '',
    cteratetype: '',
    cterentalamount: 0,
    ctervamount: 0,
    ctervcoef: 0,
    ctestartamount: 100000,
    ctestartdate: '',
    ctestatus: '',
    ctetype: '',
    cteunit: '',
    cteupfrontamount: 0,
    ctrid: 0,
    currcode: '',
    last_action: '',
    prefinbasis: '' as any,
    prefinmethod: '',
    prefinnominalrate: '' as any,
    prefinperiodicity: '' as any,
    prefinrateformula: '' as any,
    prefinratetype: '' as any,
    rvcalculationmode: '',
    rvevaluationmode: '',
    prefinrateref: '' as any,
    prefinratespread: 0,
    cterateref: 0,
    priid: 0,
    taxcode: '',
    taxrate: 0,
    taxtype: '' as any,
    tpid: 0,
    tpidparticipation: '' as any,
    calculatedamountbasis: '',
    marginoncalulatedcamount: 0,
    additionalcostaftermargin: 0,
    servfixedamount: 0,
    servpercentage: 0,
    deferredinterestratetype: 0,
    pritype: '',
    helpers: {
      servfixedamountmin: '' as any,
      servpercentagemin: '' as any,
      servcontextmin: '' as any,
      durationmax: 0,
      durationcontextmax: 0,
      durationcontextmin: 0,
      durationmin: 0,
      frmin: 0,
      frmax: 0,
      frcontextmax: 0,
      frcontextmin: 0,
      upmax: 0,
      upmin: 0,
      rvmax: 0,
      rvmin: 0,
      rvcontextmax: 0,
      rvcontextmin: 0,
      marginratemin: '' as any,
      margincontextmin: '' as any,
      marginratemax: '' as any,
      margincontextmax: '' as any,
      gpdurationmax: '' as any,
      ratemax: 0,
      ratemin: 0,
      ratecontextmax: 0,
      ratecontextmin: 0,
    },
    spvassetdiscount: '' as any,
    spvriskrate: '' as any,
    spvadditionalfees: '' as any,
    spvloancoef: '' as any,
    spvdiscountsale: '' as any,
    spvinflation: '' as any,
    serviceResponse: {
      servcode: '',
      servlabel: '',
      tpidsupplier: 0,
      servduration: '',
      servcalculationmethod: '',
      servpercentage: 0,
      servfixedamount: 0,
      servrepaypercentage: 0,
      startdate: '',
      enddate: '' as any,
      servstatus: '',
      taxcode: '',
      servrepayfixedamount: 0,
      servrepaymode: '',
      servperiodicity: '',
      servdurationdefault: 0,
      servtype: '',
      flagautoexpense: '' as any,
      servbasis: '',
      servbasislabel: '',
      servtypelabel: '',
      servrepaymodelabel: '',
      servperiodicitylabel: '' as any,
      servstatuslabel: '',
      servdurationlabel: '',
      servcalculationmethodlabel: '',
      tpname: '',
      tpreference: '',
      tprole: '',
      calculatedamountbasis: '',
      marginoncalulatedamount: '' as any,
      additionalcostaftermargin: 0,
      citype: '',
      ciltype: '',
      cilcategory: '',
      calculatedamountbasislabel: '',
      citypelabel: '' as any,
      ciltypelabel: '',
      cilcategorylabel: '',
      servcategory: '',
      servcategorylabel: '',
      currcode: '' as any,
    },
    commissionResponse: [],
    serviceStepList: [],
    pricing: {
      priid: 0,
      prilabel: '',
      cteid: '' as any,
      ctetype: '' as any,
      ctecategory: '' as any,
      finamountmin: 0,
      finamountmax: 0,
      calculationmethod: '',
      calculationbasis: '',
      rateformula: '',
      ratetype: '',
      rateperiodicity: 0,
      ratevaluedefault: 0,
      ratespreadmin: 0,
      ratespreadmax: 0,
      ratespreaddefault: 0,
      ratereqtype: '',
      ratereqreceivertype: '',
      ratereqreceiverroleprofile: '',
      ratereqreceiverid: 0,
      durationmin: 0,
      durationmax: 0,
      durationdefault: 0,
      durationreqtype: '',
      durationreqreceivertype: '',
      durationreqreceiverroleprofile: '',
      durationreqreceiverid: 0,
      periodicity: '',
      unit: '',
      interestmethod: '',
      term: '',
      gpduration: '' as any,
      gpmethod: '',
      firstrentalmin: 0,
      firstrentalmax: 0,
      firstrentaldefault: 0,
      firstrentalreqtype: '',
      firstrentalreqreceivertype: '',
      firstrentalreqreceiverroleprofile: '',
      firstrentalreqreceiverid: 0,
      rvmin: '' as any,
      rvmax: '' as any,
      rvdefault: '' as any,
      rvreqtype: '',
      rvreqreceivertype: '',
      rvreqreceiverroleprofile: '',
      rvreqreceiverid: 0,
      serviceduration: '' as any,
      servcalculationmethod: '' as any,
      servpercentage: '' as any,
      servfixedamount: '' as any,
      servreqtype: '' as any,
      servreqreceivertype: '' as any,
      servreqreceiverroleprofile: '' as any,
      servreqreceiverid: '' as any,
      pristatus: '',
      startdate: '',
      enddate: '' as any,
      pridescription: '' as any,
      servfixedamountmin: '' as any,
      servpercentagemin: '' as any,
      ctebilligdate: '' as any,
      flagmandatory: false,
      flagupdate: false,
      taxcode: '',
      deferredinterestmethod: '',
      deferredinterestnominalrate: '' as any,
      depositamount: '' as any,
      depositcoef: '' as any,
      depositinterestmethod: '',
      depositnominalrate: '' as any,
      rvdefaultamount: 0,
      flagfollowgraceperiod: false,
      prefinmethod: '',
      prefinnominalrate: '' as any,
      prefinbasis: '' as any,
      prefinperiodicity: '' as any,
      prefinratetype: '' as any,
      prefinrateformula: '' as any,
      partmethod: '',
      partamount: '' as any,
      partrate: '' as any,
      tpidparticipation: '' as any,
      partnbdays: 0,
      tprole: '' as any,
      allowfinservice: false,
      upfrontmin: 0,
      upfrontmax: 0,
      upfrontdefault: 0,
      upfrontreqtype: '',
      upfrontreqreceivertype: '',
      upfrontreqreceiverroleprofile: '',
      upfrontreqreceiverid: 0,
      spvassetdiscount: '' as any,
      spvriskrate: '' as any,
      spvadditionalfees: '' as any,
      spvloancoef: '' as any,
      spvdiscountsale: '' as any,
      spvinflation: '' as any,
      rvcontextmax: '' as any,
      rvcontextmin: '' as any,
      rvauthid: '' as any,
      rvtaskid: '' as any,
      ratecontextmax: '' as any,
      ratecontextmin: '' as any,
      rateauthid: '' as any,
      ratetaskid: '' as any,
      frcontextmax: '' as any,
      frcontextmin: '' as any,
      frauthid: '' as any,
      frtaskid: '' as any,
      durationcontextmax: '' as any,
      durationcontextmin: '' as any,
      durationauthid: '' as any,
      durationtaskid: '' as any,
      rvcalculationmode: '' as any,
      rvevaluationmode: '' as any,
      cttype: '' as any,
      currcode: '' as any,
      marginratemin: '' as any,
      marginratemax: '' as any,
      marginratedefault: '' as any,
      marginratereqtype: '' as any,
      marginratereqreceivertype: '' as any,
      marginratereqreceiverroleprofile: '' as any,
      marginratereqreceiverid: '' as any,
      margincontextmin: '' as any,
      margincontextmax: '' as any,
      marginauthid: '' as any,
      margintaskid: '' as any,
      servcontextmin: '' as any,
      servauthid: 0,
      servtaskid: 0,
    },
    pricingStepList: [],
    rvauthid: 0,
    rvtaskid: 0,
    rateauthid: 0,
    ratetaskid: 0,
    frauthid: 0,
    frtaskid: 0,
    durationauthid: 0,
    durationtaskid: 0,
    servtaskid: 0,
    servauthid: 0,
    margintaskid: 0,
    marginauthid: 0,
    ctefeesamount: 0,
    ctecommissionamount: 0,
    cteprofitabilityrate: 0,
    cteaprrate: 0,
    cteflatrate: 0,
    ctecoefrate: 0,
    ctefundingrate: 0,
    ctefundingperiodicity: 0,
    ctefundinginstallment: 0,
    ctefundingcost: 0,
    ctemarginamount: 0,
    ctemarginrate: 0,
    ctevatdeferralamount: 0,
    ctevatdeferralduration: 0,
    ctevatdeferralmethod: '',
    ctevatdeferraldaysbasis: 0,
    cteextracosttofinance: 0,
    cteextracostcomment: '',
    totalInterest: 0,
    totalRental: 0,
    totalAmortization: 0,
    totaldiscountedInterest: 0,
    totalVatDeffered: 0,
    totaldiscountedOutstanding: 0,
    totaldiscountedAgiosdeb: 0,
    totalAgiosdeb: 0,
    marginImpactCredit: 0,
    marginImpactDebit: 0,
    dgo: 0,
    profitabilityAmount: 0,
  };

  const [state, setstate] = useState<any>({
    installementamount: 0,
    duration: 0,
    pricing: updateService ? record.pricing : {},
    servElement: updateService ? record : initobj,
  });

  const [data, setData] = useState<any>(updateService ? record : initialValues);
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [Btnloading, setBtnloading] = useState<boolean>(false);

  const [pricing, setPricing] = useState<Pricing>(
    updateService ? record?.pricing : initialValues?.pricing
  );

  let [serviceResponse, setServiceResponse] = useState<any>(
    updateService ? record?.serviceResponse : initialValues?.serviceResponse
  );

  const reset = () => {
    form?.setFieldsValue({
      servbasis: '',
    });
    form?.setFieldsValue({
      servbasisamount: 0,
    });
    form?.setFieldsValue({
      service: '',
    });
    form?.setFieldsValue({
      additionalcostaftermargin: 0,
    });
    form?.setFieldsValue({
      calculatedamountbasis: '',
    });
    form?.setFieldsValue({
      marginoncalulatedcamount: 0,
    });
    form?.setFieldsValue({
      servbasis: '',
    });
    form?.setFieldsValue({
      servcalculationmethod: '',
    });
    form?.setFieldsValue({
      servduration: '',
    });
    form?.setFieldsValue({
      servdurationdefault: 0,
    });
    form?.setFieldsValue({
      servfixedamount: 0,
    });
    form?.setFieldsValue({
      servpercentage: 0,
    });
    form?.setFieldsValue({
      servperiodicity: '',
    });
    form?.setFieldsValue({
      servtype: '',
    });
    setstate({ ...state, servElement: updateService ? record : initobj });
    setData(initialValues);
  };

  useEffect(() => {
    if (record && updateService) {
      form.setFieldsValue({
        overallduration: record?.overallduration ?? 0,
        remainingduration: record.is_new
          ? record?.cteduration
          : record?.remainingduration,
        servbasisamount:
          record.servbasis ?? record?.serviceResponse.servfreebasisdefault ?? 0,
        servbasis:
          record?.serviceResponse?.servbasis === ''
            ? record?.serviceResponse?.servbasislabel
            : record?.serviceResponse?.servbasis ?? '',

        additionalcostaftermargin:
          record.additionalcostaftermargin === 0
            ? record?.serviceResponse.additionalcostaftermargin
            : record.additionalcostaftermargin ?? 0,

        calculatedamountbasis:
          record?.serviceResponse?.calculatedamountbasis === ''
            ? record?.serviceResponse?.calculatedamountbasislabel
            : record?.serviceResponse?.calculatedamountbasis ?? '',

        marginoncalulatedcamount:
          record.marginoncalulatedcamount === undefined
            ? record?.serviceResponse?.marginoncalulatedamount
              ? record?.serviceResponse?.marginoncalulatedamount
              : record?.serviceResponse?.marginoncalulatedcamount
            : record.marginoncalulatedcamount ?? 0,

        servcalculationmethod:
          record?.serviceResponse?.servcalculationmethod === ''
            ? record?.serviceResponse?.servcalculationmethodlabel
            : record?.serviceResponse?.servcalculationmethod ?? '',

        servduration: record?.serviceResponse?.servduration ?? '',

        servdurationdefault:
          record?.cteduration ??
          record?.serviceResponse?.servdurationdefault ??
          0,
        servfixedamount:
          record?.servfixedamount ??
          record?.serviceResponse?.servfixedamount ??
          0,
        servpercentage:
          record?.servpercentage ?? record?.serviceResponse.servpercentage ?? 0,
        servperiodicity: record?.serviceResponse?.servperiodicity ?? '',

        servtype: record?.serviceResponse?.servtype ?? '',
        service: record?.priid,
      });
    } else reset();
  }, [record, visible, updateService]);

  const handlePricingChange = (pricing: any) => {
    setLoading(true);
    state.pricing = pricing;

    serviceResponse = pricing?.serviceResponse;
    setServiceResponse(pricing?.serviceResponse);

    if (pricing != null && form) {
      form.setFieldsValue({
        servbasis: pricing?.serviceResponse?.servbasis ?? '',
        servbasisamount: pricing?.serviceResponse?.servfreebasisdefault ?? 0,
        additionalcostaftermargin:
          pricing?.serviceResponse?.additionalcostaftermargin ?? 0,
        calculatedamountbasis:
          pricing?.serviceResponse?.calculatedamountbasis ?? '',
        marginoncalulatedcamount:
          pricing?.serviceResponse?.marginoncalulatedamount ?? 0,
        servcalculationmethod:
          pricing?.serviceResponse?.servcalculationmethod ?? '',
        servduration: pricing?.serviceResponse?.servduration ?? '',
        servdurationdefault:
          pricing?.serviceResponse?.servdurationdefault > cteduration
            ? cteduration
            : pricing?.serviceResponse?.servdurationdefault ?? 0,
        servfixedamount: pricing?.serviceResponse?.servfixedamount ?? 0,
        servpercentage: pricing?.serviceResponse?.servpercentage ?? 0,
        servperiodicity: pricing?.serviceResponse?.servperiodicity ?? '',
        servtype: pricing?.serviceResponse?.servtype ?? '',
      });

      setData({
        ...data,
        ...data.pricing,
        pricing: pricing,
        serviceResponse: {
          ...pricing.serviceResponse,
        },
        servfixedamount: pricing?.serviceResponse?.servfixedamount,

        additionalcostaftermargin:
          pricing?.serviceResponse?.additionalcostaftermargin,

          servpercentage: pricing?.serviceResponse?.servpercentage,

        servbasisamount: pricing?.serviceResponse?.servfreebasisdefault ?? 0,
      });

      setPricing(pricing);

      calculateServiceNew(pricing);
    } else {
      setLoading(false);
      reset();
    }
  };

  const [schedule, setschedule] = useState<any>({ schedule: [] });
  const calculateServiceNew = debounce((servElement: any) => {
    let schedule: any;

    setLoading(true);

    let servdurationdefault =
      form?.getFieldValue('servdurationdefault') > cteduration
        ? cteduration
        : form?.getFieldValue('servdurationdefault') ??
          data?.serviceResponse?.servdurationdefault;

    const servstep = updateService
      ? data.serviceStepList?.length === 0
        ? data.conElemSteps ?? []
        : data.serviceStepList ?? []
      : data.serviceStepList ?? [];

    let new_finschedule = finschedule?.filter(
      (e: any) => e.ctsduedate >= ctestartdate
    );

    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: new_finschedule,
          inDownPayment: 0,
          inFinAmount: ctefinancedamount,
          inFollowGP: data.pricing?.flagfollowgraceperiod,
          inGPDuration: ctegraceperiodduration,
          inPstype: state.pricing.ctecategory,
          inRoudingAmount: 2,
          inServcalculationmethod:
            form?.getFieldValue('servcalculationmethod') ??
            data?.serviceResponse?.servcalculationmethod,
          inServfixedamount:
            form?.getFieldValue('servfixedamount') ?? data?.servfixedamount,
          inServiceduration:
            form?.getFieldValue('servduration') ??
            data?.serviceResponse?.servduration,
          inServpercentage:
            form?.getFieldValue('servpercentage') ?? data?.servpercentage,
          inTaxcode: updateService ? data?.taxcode : data.pricing.taxcode,
          inTaxrate: data?.taxrate ?? 20, // TODO : get taxrate :
          inDuration: cteduration,
          inInvestAmount: cteinvestamount,
          inAssetAmount: assetamount,
          inServperiodicity:
            form?.getFieldValue('servperiodicity') ??
            data?.serviceResponse?.servperiodicity,
          inServDurationFree: updateService
            ? data.remainingduration ?? form?.getFieldValue('remainingduration')
            : form?.getFieldValue('servdurationdefault') ?? servdurationdefault,

          inStartDate: ctestartdate
            ? moment(ctestartdate).format('YYYY-MM-DD')
            : '',
          inServbasis:
            form?.getFieldValue('servbasis') ??
            data?.serviceResponse?.servbasis,

          inCalculatedamountbasis:
            form?.getFieldValue('calculatedamountbasis') ??
            data?.serviceResponse?.calculatedamountbasis,

          inMarginoncalcultedamount:
            form?.getFieldValue('marginoncalulatedcamount') ??
            data?.marginoncalulatedcamount,
          inAdditionalcostaftermargin:
            form?.getFieldValue('additionalcostaftermargin') ??
            data?.additionalcostaftermargin,

          servStep: servstep,
        },
      })
      .then((res) => {
        setLoading(false);
        setBtnloading(false);

        if (res.success) {
          form?.setFieldsValue({
            servdurationdefault: res.duration ?? 0,
          });
          setschedule({ ...schedule, schedule: res.paymentSchedule });
          setstate({
            ...state,
            installementamount: res.installmentamount,
            duration: res.duration,
          });
          message.success(res.message);

          let newOverallduration =
            record.oldoverallduration -
            (record.oldremainingduration - data.remainingduration);

          data.overallduration = newOverallduration;
          form.setFieldValue('overallduration', newOverallduration);
        }
      })
      .catch((err) => {
        setLoading(false);
        setBtnloading(false);
      });
  }, 2000);

  const columns = useMemo<DataGridColDef<ParServiceStep>[]>(
    () => [
      {
        dataIndex: 'steporder',
        fixed: 'left',
        width: 120,
      },
      {
        dataIndex: 'stepunit',
        width: 120,
      },
      {
        dataIndex: 'stepduration',
        width: 120,
      },
      {
        dataIndex: 'deprpercentage',

        render: toRate,
        width: 120,
      },
      {
        dataIndex: 'servpercentage',

        render: toRate,
        width: 120,
      },
      {
        dataIndex: 'servamount',

        render: toCurrency,
        width: 120,
      },
    ],

    []
  );
  const newelem = () => {
    const price = state.pricing;
    const serv = {
      ...data,
      ...pricing,
      servfixedamount: data?.servfixedamount,
      pricing: pricing,
      durationdefault: form?.getFieldValue('servdurationdefault'),
      servbasis: data.servbasis,
      serviceResponse: {
        ...data?.serviceResponse,
      },
      periodicity: form?.getFieldValue('servperiodicity'),
      servpercentage: form?.getFieldValue('servpercentage'),
    };

    const offer = { ofrid: 0, ofrlabel: '', ofrtype: '', ofrdescription: '' };
    const res = ServiceToElement(
      offer,
      serv,
      cteinvestamount,
      schedule.schedule,
      state.installementamount,
      cteidparent,
      form?.getFieldValue('servbasisamount')
    );

    res.pritype = 'PRICING';

    return res;
  };

  const updateElem = () => {
    const offer = { ofrid: 0, ofrlabel: '', ofrtype: '', ofrdescription: '' };

    const elem: any = pricingToElement(
      offer,
      data,
      cteinvestamount,
      0,
      0,
      0,
      0,
      cteidparent,
      schedule?.schedule
    );

    elem.pritype = 'PRICING';

    const newElem = {
      ...record,
      ...elem,
      cteid: record.cteid ?? 0,
      ctedescription: record.ctedescription,
      servfixedamount: data?.servfixedamount,
      pricing: pricing,
      servbasis: data.servbasis,
      durationdefault: state.duration,
      cteduration: state.duration,
      servpercentage: form?.getFieldValue('servpercentage'),
      overallduration: data.overallduration,
      remainingduration: data.remainingduration,
      cteinstallmentamount: state.installementamount,
      servbasisamount: data.servbasis,
      oldservbasisamount: record.oldservbasisamount ?? 0,
      serviceResponse: {
        ...data?.serviceResponse,
      },
      periodicity: form?.getFieldValue('servperiodicity'),
    };

    return newElem;
  };

  return (
    (<div onClick={(e) => e.stopPropagation()}>
      <Modal
        open={visible}
        title={updateService ? 'Update Service' : 'Add Service'}
        onCancel={() => {
          onClose();
          reset();
        }}
        width="1400px"
        style={{ top: 20 }}
        footer={null}
        destroyOnClose
      >
        <Spin spinning={loading}>
          <Card bordered>
            <Form
              form={form}
              onFinish={() => {
                if (isEmpty(state.pricing)) {
                  notification.error({ message: 'Select Pricing' });
                } else {
                  onSave(
                    updateService ? updateElem() : newelem(),
                    updateService ? 'update' : 'create'
                  );
                  reset();
                  onClose();
                }
              }}
            >
              <Tabs
                type="card"
                tabBarExtraContent={
                  <Row gutter={24}>
                    <Col span={updateService ? 2 : 3} />
                    <Col span={11}>
                      <ServiceScheduleModal
                        currcode={form?.getFieldValue('currcode')}
                        financialSchedule={
                          schedule?.schedule !== undefined &&
                          schedule?.schedule?.length !== 0
                            ? schedule?.schedule
                            : record?.conElemSchedules
                        }
                        controller={
                          <ScheduleButton
                            comcode="PaymentScheduleButton"
                            twoToneColor="blue"
                          />
                        }
                      />
                    </Col>
                    <Col span={4}>
                      <Button key="Cancel" onClick={onClose}>
                        Cancel
                      </Button>{' '}
                    </Col>
                    <Col span={4}>
                      <Button
                        key="Validate"
                        type="primary"
                        loading={loading || Btnloading}
                        onClick={() => {
                          form.submit();
                        }}
                        icon={
                          updateService ? (
                            <IUpdate color="white" height="16px" width="13px" />
                          ) : (
                            <IAdd
                              color="white"
                              width="14px"
                              height="14px"
                              svgStyle={{ marginTop: '3px' }}
                            />
                          )
                        }
                      >
                        {updateService ? 'Update' : 'Add'}
                      </Button>
                    </Col>
                  </Row>
                }
              >
                <TabPane key={1} tab={<GetLabel label="Quotation" />}>
                  <Row></Row>
                  <br />
                  <FormInput col xl={14} name="service">
                    <PricingListSelect
                      params={{
                        offerid: offerid,
                        ctecategory: '',
                        ctetype: updateService ? record?.ctetype : 'SERV',
                        filters: '',
                        finamount: cteinvestamount,
                      }}
                      disabled={updateService}
                      defaultValue={record?.pricing?.priid}
                      onlyServ
                      allowClear
                      onChange={(e) => {
                        setBtnloading(true);
                        handlePricingChange(e);
                      }}
                    />
                  </FormInput>
                  <Row gutter={[16, 16]}>
                    <FormInput col xl={14} name="asset">
                      <Select
                        style={{ width: '100%' }}
                        onChange={(e) => {
                          setBtnloading(true);
                          form?.setFieldsValue({ cteinvestamount: e });
                          data.cteinvestamount = e;
                          calculateServiceNew(record);
                        }}
                        allowClear
                      >
                        {assets
                          ?.filter((asset: any) => asset?.cteid === cteidparent)
                          ?.map((asset: any) => (
                            <Select.Option
                              value={asset.assetnetamount}
                              key={asset.assetid}
                            >
                              {asset.assetlabel}
                            </Select.Option>
                          ))}
                      </Select>
                    </FormInput>
                    <Col span={2}></Col>
                    <FormInput
                      name="cteinvestamount"
                      shouldUpdate={shouldUpdateCompare('cteinvestamount')}
                      col
                      md={6}
                    >
                      <Value
                        formatter={(value) =>
                          toCurrency(
                            value,
                            form?.getFieldValue('currcode') ??
                              localStorage.getItem('currcode') ??
                              ''
                          )
                        }
                      />
                    </FormInput>
                  </Row>

                  <Divider />
                  <Row gutter={32}>
                    <Form.Item noStyle shouldUpdate>
                      <FormInput col xl={6} name="servtype" shouldUpdate>
                        <ParListSelect
                          style={{ width: 500 }}
                          parcode="CTETYPE"
                          disabled
                          onSelect={(e) => {
                            setBtnloading(true);
                            data.serviceResponse.servtype! = e;
                          }}
                        />
                      </FormInput>
                      <FormInput col xl={6} name="servbasis" shouldUpdate>
                        <ParListSelect
                          parcode="SERVBASIS"
                          disabled
                          onSelect={(e) => {
                            setBtnloading(true);
                            calculateServiceNew(data);
                            data.serviceResponse.servbasis = e;
                          }}
                        />
                      </FormInput>
                      <FormInput col xl={6} name="servbasisamount" shouldUpdate>
                        <InputCurrency
                          currcode={
                            form?.getFieldValue('currcode') ??
                            localStorage.getItem('currcode') ??
                            ''
                          }
                          onChange={(e) => {
                            data.servbasis = Number(e);
                            setBtnloading(true);
                            calculateServiceNew(data);
                          }}
                          disabled={serviceResponse?.servbasis !== 'FREE'}
                        />
                      </FormInput>
                      <FormInput
                        col
                        xl={6}
                        name="calculatedamountbasis"
                        shouldUpdate
                      >
                        <ParListSelect parcode="SERVCALMNT" disabled />
                      </FormInput>
                      <FormInput col xl={6} name="servduration">
                        <ParListSelect
                          parcode="SERVDUR"
                          disabled
                          onSelect={(e) => {
                            setBtnloading(true);
                            calculateServiceNew(data);
                          }}
                        />
                      </FormInput>
                      <FormInput col xl={6} name="servperiodicity" shouldUpdate>
                        <ParListSelect
                          style={{ width: '500px' }}
                          parcode="SERVPER"
                          disabled
                          onSelect={(e) => {
                            setBtnloading(true);
                            calculateServiceNew(data);
                          }}
                        />
                      </FormInput>
                      {!updateService || record.is_new ? (
                        <FormInput
                          col
                          xl={6}
                          name="servdurationdefault"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (value <= cteduration) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error(
                                    getComponentLabel(
                                      'servdurationdefault_max'
                                    ) +
                                      ' : ' +
                                      cteduration
                                  )
                                );
                              },
                            }),
                          ]}
                        >
                          <InputNumber
                            disabled={
                              (serviceResponse?.servduration !== 'FREE' &&
                                serviceResponse?.servduration !== 'STEPFREE') ||
                              updateService
                            }
                            onChange={(e) => {
                              setBtnloading(true);
                              calculateServiceNew(data);
                            }}
                            max={cteduration}
                          />
                        </FormInput>
                      ) : (
                        <FormInput
                          col
                          xl={6}
                          name="overallduration"
                          shouldUpdate
                        >
                          <InputNumber
                            disabled={
                              (serviceResponse?.servduration !== 'FREE' &&
                                serviceResponse?.servduration !== 'STEPFREE') ||
                              updateService
                            }
                            onChange={(e) => {
                              data.overallduration = Number(e);
                              setBtnloading(true);
                              calculateServiceNew(data);
                            }}
                          />
                        </FormInput>
                      )}
                      <FormInput
                        col
                        xl={6}
                        name="servcalculationmethod"
                        shouldUpdate
                      >
                        <ParListSelect
                          parcode="SERVCALMET"
                          disabled
                          onChange={(e) => {
                            data.serviceResponse.servcalculationmethod! = e;
                          }}
                        />
                      </FormInput>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                         
                          return (
                            <FormInput
                              col
                              xl={6}
                              name="servfixedamount"
                              shouldUpdate
                            >
                              <InputCurrency
                                currcode={
                                  form?.getFieldValue('currcode') ??
                                  localStorage.getItem('currcode') ??
                                  ''
                                }
                                onChange={(e) => {
                                  setBtnloading(true);
                                  data.servfixedamount = Number(e);
                                  calculateServiceNew(state.servElement);
                                }}
                                min={data.helpers?.servfixedamountmin}
                                disabled={
                                  getFieldValue('servcalculationmethod') ===
                                    'PERCENT' && !data?.flagupdate
                                }
                              />
                            </FormInput>
                          );
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            <FormInput
                              col
                              xl={6}
                              name="servpercentage"
                              shouldUpdate
                            >
                              <InputRate
                                precision={5}
                                min={
                                  data.helpers?.servpercentagemin ??
                                  data.serviceResponse?.servpercentage
                                }
                                onChange={(e) => {
                                  setBtnloading(true);
                                  data.servpercentage! = Number(e);
                                  calculateServiceNew(data);
                                }}
                                disabled={
                                  getFieldValue('servcalculationmethod') ===
                                    'FIXED' && !data?.flagupdate
                                }
                              />
                            </FormInput>
                          );
                        }}
                      </Form.Item>

                      <FormInput
                        col
                        xl={6}
                        name="marginoncalulatedcamount"
                        shouldUpdate
                      >
                        <InputRate
                          precision={2}
                          onChange={(e) => {
                            data.marginoncalulatedcamount = Number(e);
                            calculateServiceNew(data);
                          }}
                          disabled={
                            !(
                              serviceResponse?.servcalculationmethod ===
                              'FIXPERMAR'
                            ) || updateService
                          }
                        />
                      </FormInput>
                      <FormInput
                        col
                        xl={6}
                        name="additionalcostaftermargin"
                        shouldUpdate
                      >
                        <InputRate
                          precision={2}
                          onChange={(e) => {
                            data.serviceResponse.additionalcostaftermargin =
                              Number(e);
                            data.additionalcostaftermargin = Number(e);
                            calculateServiceNew(data);
                          }}
                          disabled={
                            serviceResponse?.servcalculationmethod ===
                              'FIXPERMAR' || updateService
                          }
                        />
                      </FormInput>

                      {updateService && (
                        <FormInput col xl={6} name="remainingduration">
                          <InputNumber
                            onChange={(e) => {
                              setBtnloading(true);
                              calculateServiceNew(data);
                              data.remainingduration = Number(e);
                            }}
                            max={cteduration}
                            min={0}
                          />
                        </FormInput>
                      )}
                    </Form.Item>
                  </Row>
                </TabPane>

                {(data.pricing?.serviceResponse?.servduration === 'STEP' ||
                  serviceResponse?.servduration === 'STEP') && (
                  <TabPane key={2} tab={<GetLabel label="Steps" />}>
                    <Row>
                      <FormInput name="steps">
                        <DataGrid
                          rowKey="stepid"
                          dataSource={
                            updateService
                              ? record.serviceStepList.length === 0
                                ? record.conElemSteps
                                : record.serviceStepList ?? []
                              : data.serviceStepList ?? []
                          }
                          titleComcode="steps"
                          columns={columns}
                        />
                      </FormInput>
                    </Row>
                  </TabPane>
                )}
              </Tabs>
            </Form>
          </Card>
        </Spin>
      </Modal>
    </div>)
  );
};

export default SimpleServElementModal;
